import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"min-width":"100%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfigAPI2 = _resolveComponent("ConfigAPI2")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ConfigAPI2, {
      companyId: _ctx.companyId,
      inProfileId: 
                _ctx.company && _ctx.company.profile && _ctx.company.profile.id ? _ctx.company.profile.id : ''
            ,
      mode: 'Accounting'
    }, null, 8, ["companyId", "inProfileId"])
  ]))
}